import React from "react";
import { ElementsViewer } from "@wuilt/section-preview";
import useElements from "../hooks/useElements";
function Video(props) {
  const wuiltContext = useElements();
  const {
    value
  } = props;
  const {
    width = "100%",
    controls = true,
    height = "300px"
  } = value;
  const element = {
    id: props?.value?.id,
    settings: {
      ...value,
      width,
      controls,
      height
    }
  };
  return /*#__PURE__*/React.createElement(ElementsViewer.Video, {
    element: element,
    wuiltContext: wuiltContext
  });
}
export default Video;
//# sourceMappingURL=Video.js.map